import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  IAllocatorDataProps,
  IMyAllocatorInitialState,
} from 'redux/saga/lenders/Allocator.types';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { APIStatus } from '../../../services/api/apiStatusCode';
import { IActionPayload } from '../../types/UserPermission.types';

export const myLendersInitialState: IMyAllocatorInitialState = {
  status: APIStatus.INIT,
  lenderData: [],
  // lenderData: ALLOCATORS.allocatorList,
  isLoading: false,
  error: {},
};

const lenderSlice = createSlice({
  name: 'lenderPermission',
  initialState: myLendersInitialState,
  reducers: {
    fetchMyAllocator: (state, action: PayloadAction<AllocatorListPayload>) => {
      state.isLoading = true;
      state.status = APIStatus.PENDING;
    },
    fetchMyAllocatorSucceeded: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IAllocatorDataProps[]>
    ) => {
      state.lenderData = action.payload;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      state.isLoading = false;
      state.status = APIStatus.SUCCESS;
    },
    fetchMyAllocatorFailed: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IActionPayload>
    ) => {
      const { error } = action.payload;
      state.error = error;
      state.isLoading = false;

      state.status = APIStatus.ERROR;
    },
    resetLenderState: () => myLendersInitialState,
  },
});

export const {
  fetchMyAllocator,
  fetchMyAllocatorSucceeded,
  fetchMyAllocatorFailed,
  resetLenderState,
} = lenderSlice.actions;

export default lenderSlice.reducer;
